export default "__VITE_ASSET__BKS8mRKS__"